// JsFromRoutes CacheKey fa1b3ae7c7a1f2a9a868996f1d076a2a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  categories: /* #__PURE__ */ definePathHelper('get', '/consumer/greeting_cards/categories'),
  default: /* #__PURE__ */ definePathHelper('get', '/consumer/greeting_cards/default'),
  demo: /* #__PURE__ */ definePathHelper('get', '/consumer/greeting_cards/demo'),
  showcaseCard: /* #__PURE__ */ definePathHelper('get', '/consumer/greeting_cards/showcase_card'),
  preview: /* #__PURE__ */ definePathHelper('get', '/consumer/greeting_cards/:id/preview'),
  createCustom: /* #__PURE__ */ definePathHelper('post', '/consumer/greeting_cards/create_custom'),
  show: /* #__PURE__ */ definePathHelper('get', '/consumer/greeting_cards/:id'),
}
